import { Component, ViewChild, AfterViewInit, OnInit, ElementRef, HostListener } from '@angular/core';
import { NgbCarousel, NgbSlideEvent } from '@ng-bootstrap/ng-bootstrap';
import { ButtonClickService } from 'src/app/shared/services/button-click.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { SessionService } from 'src/app/shared/services/session.service';
import { ProfileService } from 'src/app/shared/services/profile.service';
import { MatDialog } from '@angular/material/dialog';
import { ModalTncComponent } from 'src/app/shared/components/modal-tnc/modal-tnc.component';
import { WalletSummaryService } from 'src/app/shared/services/api/wallet-summary.service';
import { TransactionHistoryService } from 'src/app/shared/services/api/transaction-history.service';
import { WalletSummary } from 'src/app/shared/models/wallet-summary.interface';
import { GetGuidService } from 'src/app/shared/services/api/get-guid.service';
import { ONLStartWalletSession } from 'src/app/shared/models/session.model';
import { HttpClient } from '@angular/common/http';
import { GetWalletNotificationService } from 'src/app/shared/services/api/get-wallet-notification.service';
import { ModalTncWalletComponent } from 'src/app/shared/components/modal-tnc-wallet/modal-tnc-wallet.component';
import { event } from 'jquery';
import { ModalDefaultPaymentComponent } from 'src/app/shared/components/modal-default-payment/modal-default-payment.component';
import { InvoicesDetailService } from 'src/app/shared/services/api/invoices-detail.service';
import { AuthService } from '@auth0/auth0-angular'; // Import AuthService


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})

export class HomeComponent implements AfterViewInit, OnInit {
  userClaims: any; // Add userClaims property to store user claims
  id: string = '';
  walletId: string = '';
  walletRole: string = '';
  autoPay: number = 0;

  policyNumber: string = '';
  productType: string = '';
  billingType: string = '';
  productSystem: string = '';


  walletSummary: WalletSummary | null = null;
  loading: boolean = true; // Add loading flag

  totalCashBalance: string | null = null;
  totalRewardBalance: string | null = null;
  totalRewardValue: string | null = null;

  cashEligible = false;
  rewardEligible = false;

  claimPayments: any[] = [];

  notifications: any[] = []; // Array to hold notifications
  errorMessage: string = ''; // Variable to hold error messages

  isLoading: boolean = true; // Centralized loading state
  isPPI: boolean = false;
  isBilliant: boolean = false;

  invoiceErrors: any[] = [];

  @ViewChild('carousel', { static: true }) carousel!: NgbCarousel;
  @ViewChild('tooltipCashInfo') tooltipCashInfoElement: ElementRef;

  // images = [
  //   { title: 'First Slide', src: 'assets/images/DigitalWallet_Images_2.jpg' },
  //   { title: 'Second Slide', src: 'assets/images/DigitalWallet_Images_1.jpg' },
  //   { title: 'Third Slide', src: 'assets/images/DigitalWallet_Images_3.jpg' },
  // ];

  images: { title: string; src: string; }[] = [];
  activeSlideIndex = 0;
  walletID: string;
  tooltipVisibleForCashInfo: boolean = false;


  constructor(
    public route: ActivatedRoute,
    public sessionService: SessionService,
    private profileService: ProfileService,
    public buttonClick: ButtonClickService,
    public dialog: MatDialog,
    public router: Router,
    public walletSummaryService: WalletSummaryService,
    private transactionHistoryService: TransactionHistoryService,
    public getTokenService: GetGuidService,
    private invoicesDetailService: InvoicesDetailService,
    private http: HttpClient,
    private walletNotificationService: GetWalletNotificationService,
    private auth: AuthService // Inject the AuthService
  ) {
    let sessionId = sessionStorage.getItem('sessionId');
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd && event.urlAfterRedirects === '/home') {
        console.log('NavigationEnd triggered:', event.urlAfterRedirects);
        
        this.route.params.subscribe(params => {
          this.id = params['id'];
        });
      }
      });
      
  }

  refreshHomeData(): void {
    this.isLoading = true; // Show skeleton
    this.loadWalletSummary(); // Reload wallet summary
    this.fetchTransactionHistory(); // Refresh transaction history
    this.loadInvoiceBannerErrors();
    this.isLoading = false; // Hide skeleton once data is loaded
  }


  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.id = params['id'];
    });
    let sessionId = this.id;
    const walletID = sessionStorage.getItem('WalletID');
    if(sessionStorage.getItem('SessionID')!='' && sessionStorage.getItem('SessionID')!=undefined
     && sessionStorage.getItem('SessionID')!=null)
    sessionId = sessionStorage.getItem('SessionID');
    if(sessionId!="" && sessionId!=undefined&& sessionId!=null)
      {
      
      if (sessionId != null && sessionId != undefined && sessionId != '') {
        const walletID = sessionStorage.getItem('WalletID');
        const walletRole = sessionStorage.getItem('WalletRole');

        if (!walletID || !walletRole) {
          console.warn('Missing WalletID or WalletRole. Redirecting to login.');
          this.checkSessionAndRedirect();
        } else {
          console.log('Navigated to Home. Refreshing data.');
          this.refreshHomeData();
          this.loadInvoiceBannerErrors(); // <== ✅ This must run AFTER sessionStorage is confirmed
        }
      }
    }
    else
    {
      console.log("this.auth.isAuthenticated$.subscribe line 136 home");
      
      this.auth.isAuthenticated$.subscribe((isAuthenticated) => {
        if (isAuthenticated) {
          // Remove or replace this line with the correct Router method if needed
            if (this.router.url !== '/home') {
                this.router.navigate(['/home']);
            }
          this.auth.idTokenClaims$.subscribe((claims) => {
            console.log('ID Token Claims:', claims);
            if (this.checkTokenExpiration(claims.exp)) {
              this.auth.loginWithRedirect({
                appState: { returnTo: '/home' }, // Dynamic redirect
                authorizationParams: {
                  redirect_uri: window.location.origin + '/home', // Default redirect URI
                },
              });
              return claims;
            }
            else {
              const sid = claims?.sid;
              console.log('Auth0 Session ID (sid):', sid);
              if (sid) {
                sessionStorage.setItem('sessionId', sid);
                sessionId = sid;
                let isPPI = false;

                if (sessionId) { // This block handles scenarios where a session ID is provided in the URL
                  sessionStorage.setItem("SessionID", sessionId); // Store the raw session ID from the URL
                  this.sessionService.fetchSessionObject(sessionId, isPPI).subscribe({
                    next: (response) => {
                      console.log('Session fetched:', response);
                      this.walletId=response.walletID;
                      this.walletRole=response.walletRole;
                      console.log('Session fetch complete');
                      this.walletSummaryService.walletSummary$.subscribe(summary => {
                        this.walletSummary = summary;
            
                        this.autoPay = Number(this.walletSummary?.wallet.isDWAutoPay) || 0;
            
                        this.cashEligible = summary?.wallet?.cashEligible === "True";
                        this.rewardEligible = summary?.wallet?.rewardEligible === "True";
            
                        if (this.walletSummary?.wallet?.defaultPaymentMethod !== undefined) {
                          console.log('Default Payment Method', this.walletSummary.wallet.defaultPaymentMethod);
                        } else {
                          console.log('Default Payment Method: undefined');
                        }
                        this.determineProductType();
            
                        this.loading = false; //   
            
                      });
            
                    this.loadInvoiceBannerErrors();
                    },
                    error: (error) => {
                      console.error('Error fetching session:', error);
                    },
                    complete: () => {

                        if (!sessionStorage.getItem('hasReloaded')) {
                        sessionStorage.setItem('hasReloaded', 'true');
                        window.location.reload();
                        }
                    },
                  });
                  // Validate session ID using SessionService

                }
              }
              return claims;
            }
          });
          return isAuthenticated;
        }

        else {
          console.log("User is not authenticted");
          this.auth.loginWithRedirect({
            appState: { returnTo: '/home' }, // Dynamic redirect
          });
        return isAuthenticated;
        }
      });
    }
    this.isPPI = this.sessionService.isPPI();

    this.sessionService.isBilliant$.subscribe(val => {
      this.isBilliant = val;
      console.log("Is Billiant Session:", this.isBilliant);
    });

    if (this.isPPI) {
      // PPI-specific image order
      this.images = [
        { title: 'First Slide', src: 'assets/images/DigitalWallet_Images_4.jpg' },
        // { title: 'Second Slide', src: 'assets/images/DigitalWallet_Images_1.jpg' },
        { title: 'Third Slide', src: 'assets/images/DigitalWallet_Images_3.jpg' },
      ];
    } else {
      // ONL (default) image order
      this.images = [
        { title: 'First Slide', src: 'assets/images/DigitalWallet_Images_2.jpg' },
        { title: 'Second Slide', src: 'assets/images/DigitalWallet_Images_1.jpg' },
        { title: 'Third Slide', src: 'assets/images/DigitalWallet_Images_3.jpg' },
      ];
    }

    if (sessionId) {

      this.id = sessionId;
      console.log('Browser Refreshed. Session ID : ', this.id);
      this.initializeWalletSession();

      this.walletSummaryService.walletSummary$.subscribe(summary => {
        this.walletSummary = summary;

        this.autoPay = Number(this.walletSummary?.wallet.isDWAutoPay) || 0;

        this.cashEligible = summary?.wallet?.cashEligible === "True";
        this.rewardEligible = summary?.wallet?.rewardEligible === "True";

        if (this.walletSummary?.wallet?.defaultPaymentMethod !== undefined) {
          console.log('Default Payment Method', this.walletSummary.wallet.defaultPaymentMethod);
        } else {
          console.log('Default Payment Method: undefined');
        }
        this.determineProductType();

        this.loading = false; //   

      });

      this.loadInvoiceBannerErrors();
    } else {
      this.route.params.subscribe(params => {
        this.id = params['id'];
      });
        if (this.id) {
          console.log("Session ID received:", this.id);
          this.initializeWalletSession();

          this.walletSummaryService.walletSummary$.subscribe(summary => {
            this.walletSummary = summary;

            this.autoPay = Number(this.walletSummary?.wallet.isDWAutoPay) || 0;

            this.cashEligible = summary?.wallet?.cashEligible === "True";
            this.rewardEligible = summary?.wallet?.rewardEligible === "True";

            if (this.walletSummary?.wallet?.defaultPaymentMethod !== undefined) {
              console.log('Default Payment Method', this.walletSummary.wallet.defaultPaymentMethod);
            } else {
              console.log('Default Payment Method: undefined');
            }
            this.determineProductType();

            this.loading = false; //   

          });

          this.loadInvoiceBannerErrors();
        } else {
          this.auth.isAuthenticated$.subscribe((isAuthenticated) => {
            if (isAuthenticated) {
              console.log('User is authenticated');
              this.auth.user$.subscribe((user) => {
                this.userClaims = user; // Store user claims
                console.log('User Claims:', this.userClaims);
              });
              this.auth.idTokenClaims$.subscribe((claims) => {
                console.log('ID Token Claims:', claims);
                if (this.checkTokenExpiration(claims.exp)) {
                  this.auth.loginWithRedirect({
                    appState: { returnTo: '/home' }, // Dynamic redirect
                    authorizationParams: {
                      redirect_uri: window.location.origin + '/home', // Default redirect URI
                    },
                  });
                  return true;
                }
                else {
                  const sid = claims?.sid;
                  console.log('Auth0 Session ID (sid):', sid);
                  if (sid) {
                    sessionStorage.setItem('sessionId', sid);
                    sessionId = sid;
                    let isPPI = false;

                    if (sessionId) { // This block handles scenarios where a session ID is provided in the URL
                      sessionStorage.setItem("SessionID", sessionId); // Store the raw session ID from the URL
                      this.sessionService.fetchSessionObject(sessionId, isPPI).subscribe({
                        next: (response) => {
                          console.log('Session fetched:', response);
                        this.loadWalletSummary();
                        this.loadInvoiceBannerErrors();
                        },
                        error: (error) => {
                          console.error('Error fetching session:', error);
                        },
                        complete: () => {
                          console.log('Session fetch complete');
                        },
                      });
                      // Validate session ID using SessionService

                    }
                  }
                  return true;
                }
              });
              return true;
            }

            else {
              console.log("User is not authenticted");
              this.auth.loginWithRedirect({
                appState: { returnTo: '/home' }, // Dynamic redirect
                authorizationParams: {
                  redirect_uri: window.location.origin + '/home', // Default redirect URI
                },
              });
              return true;
            }
          });
          console.error("No session ID provided in route.");
          this.checkSessionAndRedirect();
        }
    }


    //  this.fetchNotifications();
  }
  private checkTokenExpiration(exp: number): boolean {
    const currentTime = Math.floor(Date.now() / 1000);
    return Number(exp) < currentTime;
  }

  //   fetchNotifications(): void {
  //     this.walletSummaryService.walletSummary$.subscribe(summary => {
  //         if (summary && summary.wallet) {
  //             this.walletID = summary.wallet.walletID;
  //             this.walletRole = 'admin'; // Replace 'admin' with the actual value from API
  //             if (this.walletID && this.walletRole) {
  //                 this.walletNotificationService.fetchWalletNotifications(this.walletID, 'admin').subscribe(
  //                     (response) => {
  //                         if (response.success) {
  //                             this.notifications = response.inAppNotifications;
  //                             console.log('App Notification Success: ', response);
  //                         } else {
  //                             this.errorMessage = response.message; // Handle error message
  //                             console.log('App Notification Failure');
  //                         }
  //                     },
  //                     (error) => {
  //                         console.error('Error fetching notifications:', error);
  //                         this.errorMessage = 'Failed to fetch notifications'; // Handle error
  //                     }
  //                 );
  //             } else {
  //                 this.errorMessage = 'Wallet ID or Wallet Role is missing';
  //             }
  //         }
  //     });
  // }

  loadInvoiceBannerErrors(): void {
    const walletID = (sessionStorage.getItem('WalletID') || '').replace(/^"(.*)"$/, '$1');
    const walletRole = (sessionStorage.getItem('WalletRole') || '').replace(/^"(.*)"$/, '$1');
    const policyNumber = sessionStorage.getItem('policyNumber') || '';

    if (walletID && walletRole) {
      this.invoicesDetailService.fetchInvoiceDetails(walletID, walletRole, 'gw', policyNumber).subscribe(
        (res: any) => {
          this.invoiceErrors = res.errors || [];
          console.log("Loading Invoice Error: ", this.invoiceErrors)
        },
        error => console.error('Invoice errors:', error)
      );
    }
  }

  private loadWalletSummary(): void {
    this.loading = true; // Set loading to true when starting to load wallet summary
    const walletIdSes = this.walletId
    const walletRoleSes = this.walletRole;
    console.log("Wallet ID: ", walletIdSes);
    console.log("Wallet Role: ", walletRoleSes);

    if (walletIdSes && walletRoleSes) {
      this.walletSummaryService.fetchWalletSummary(walletIdSes, walletRoleSes).subscribe({
        next: (summary) => {
          this.walletSummary = summary;
          this.autoPay = Number(this.walletSummary?.wallet.isDWAutoPay) || 0;
          //      console.log("WalletSummary reloaded:", summary);
          this.loading = false; // Set loading to false when data is loaded
        },
        error: (error) => console.error("Error reloading WalletSummary:", error)
      });
    }
    else {
      console.log("No walletID or walletRole found");
    }
  }

  private determineProductType(): void {
    if (this.walletSummary?.wallet.cashEligible && !this.walletSummary?.wallet.rewardEligible) {
      this.productType = 'is4uupsbuild';
    } else {
      this.productType = '';
    }
  }

  // private checkSessionAndRedirect(): void {

  //   let sessionobj:ONLStartWalletSession=new ONLStartWalletSession();

  //   if(sessionStorage.getItem('ONLWalletSession') !=undefined)
  //   sessionobj=JSON.parse(sessionStorage.getItem('ONLWalletSession') || '{}');

  //   if(sessionobj !=null && sessionobj !=undefined && sessionobj.callBackURL !=undefined )
  //   {
  //     const walletID = sessionStorage.getItem('WalletID');
  //   if (!walletID) {
  //     // Redirect to the ONL login page if no walletID is found

  //   window.location.href=sessionobj.callBackURL;
  //   sessionStorage.clear();
  //   }

  // }

  //   // If walletID exists, it should allow the user to stay on the page
  // }

  private checkSessionAndRedirect(): void {
    const isPPI = this.sessionService.isPPI(); // or however you detect PPI session

    if (isPPI) {
      const ppiSessionRaw = sessionStorage.getItem('PPIWalletSession');
      const ppiSession = ppiSessionRaw ? JSON.parse(ppiSessionRaw) : null;

      const walletID = sessionStorage.getItem('WalletID'); // Eventually remove
      if (!walletID && ppiSession?.callBackURL) {
        console.log("No walletID found for PPI. Redirecting to:", ppiSession.callBackURL);
        sessionStorage.clear();
        window.location.href = ppiSession.callBackURL;
        return;
      }

    } else {
      const onlSessionRaw = sessionStorage.getItem('ONLWalletSession');
      const onlSession = onlSessionRaw ? JSON.parse(onlSessionRaw) : null;

      const walletID = sessionStorage.getItem('WalletID'); // Eventually remove
      if (!walletID && onlSession?.callBackURL) {
        console.log("No walletID found for ONL. Redirecting to:", onlSession.callBackURL);
        sessionStorage.clear();
        window.location.href = onlSession.callBackURL;
        return;
      }
    }

    // ✅ WalletID exists, so do nothing
  }


  // src/app/modules/home/home.component.ts

initializeWalletSession(): void {
  this.isLoading = true;
  
  // 1. Check if AuthGuard already did the work
  const currentSessionID = sessionStorage.getItem('SessionID');
  const storedWalletID = sessionStorage.getItem('WalletID');
  
  // If the ID in the URL matches the one we just stored in AuthGuard...
  if (currentSessionID === this.id && storedWalletID) {
    console.log('✅ HomeComponent: Session already loaded by AuthGuard. Hydrating from Storage.');
    
    // JUST LOAD DATA (No API Call)
    this.walletId = JSON.parse(storedWalletID); // Parse if you stored it as stringified JSON
    this.walletRole = JSON.parse(sessionStorage.getItem('WalletRole') || '""');
    this.hydrateSessionDetails();
    
    // Trigger the downstream logic immediately
    this.checkTcAcceptanceAndProceed();
    this.loadWalletSummary();
    this.isLoading = false;
    return; // ⛔ EXIT HERE. Do not make the API call below.
  }

    // ... Only proceed to API call if AuthGuard didn't run (e.g. deep linking edge cases) ...
    console.log('⚠️ HomeComponent: Session not found in storage. Fetching from API...');

    // [KEEP YOUR EXISTING API CALL LOGIC HERE AS FALLBACK]
    let isPPI = false;
    if (this.route.snapshot.routeConfig && this.route.snapshot.routeConfig.path === 'home/PPI/:id') {
      isPPI = true;
    }

   /*  this.sessionService.fetchSessionObject(this.id, isPPI).subscribe((res) => {
      console.log("insude" + JSON.stringify(res));
    }); */
  }

  // initializeWalletSession(): void {
  //   this.isLoading = true;
  //   let isPPI = false;

  //   if (this.route.snapshot.routeConfig && this.route.snapshot.routeConfig.path === 'home/PPI/:id') {
  //     isPPI = true;
  //     console.log('HomeComponent - Detected PPI Route');
  //   } else {
  //     console.log('HomeComponent - Detected ONL or other Route');
  //   }

  //   this.sessionService.fetchSessionObject(this.id, isPPI).subscribe({
  //     next: (sessionRes) => {
  //       if (sessionRes && sessionRes.message && sessionRes.message.toLowerCase() === 'success') {

  //         // ✅ STEP 1: Store Data FIRST.
  //         // This ensures the Token is ready in sessionStorage BEFORE we update the walletId.
  //         this.storeSessionDataAndCheckRedirect(sessionRes, isPPI);

  //         // ✅ STEP 2: Update Variables.
  //         // This triggers the Child Component (Table) to run ngOnChanges.
  //         // Because Step 1 happened, the Child Component will find the token and succeed!
  //         this.walletId = sessionRes.walletID;
  //         this.walletRole = sessionRes.walletRole;

  //         // --- Handle Session Properties ---
  //         if ('onlStartWalletSession' in sessionRes && (sessionRes as any).onlStartWalletSession) {
  //             const onlSession = (sessionRes as any).onlStartWalletSession;
  //             this.policyNumber = onlSession.productSystemIdentifier1;
  //             this.productType = onlSession.productType;
  //             this.productSystem = onlSession.productSystem;
  //             this.billingType = onlSession.billingType; 
  //         } else if ('ppiStartWalletSession' in sessionRes && (sessionRes as any).ppiStartWalletSession) {
  //             const ppiSession = (sessionRes as any).ppiStartWalletSession;
  //             this.policyNumber = ppiSession.productSystemIdentifier1; 
  //             this.productType = ppiSession.productType; 
  //             this.productSystem = ppiSession.productSystem; 
  //             this.billingType = ppiSession.billingType; 
  //         } else {
  //             console.warn('HomeComponent: Neither ONL nor PPI start session data found.');
  //              // Set defaults if needed
  //         }

  //         // ❌ REMOVED: You had a duplicate call to storeSessionDataAndCheckRedirect here. 
  //         // We already did it in Step 1.

  //         this.checkTcAcceptanceAndProceed();
  //         this.loadWalletSummary();

//         // ❌ REMOVED: this.fetchTransactionHistory();
//         // REASON: Your Table Component detects the change in 'walletId' (Step 2) 
//         // and fetches the history automatically. If you keep this line, you fetch it twice!
      
//       } else {
//         sessionStorage.setItem('WalletID', '');
//         this.checkSessionAndRedirect();
//       }
//       this.isLoading = false; 
//     },
//     error: (error) => {
//       console.error("Failed to fetch session object:", error);
//       this.isLoading = false; 
//       this.checkSessionAndRedirect();
//     }
//   });
// }
  

  hydrateSessionDetails(): void {
    const sessionKey = this.isPPI ? 'PPIWalletSession' : 'ONLWalletSession';
    const storedSession = sessionStorage.getItem(sessionKey);

    if (!storedSession) {
      console.warn(`HomeComponent: ${sessionKey} is not available to hydrate wallet setup data.`);
      return;
    }

    try {
      const session = JSON.parse(storedSession);
      this.policyNumber = session.productSystemIdentifier1 || '';
      this.productType = session.productType || '';
      this.productSystem = session.productSystem || '';
      this.billingType = session.billingType || '';
    } catch (error) {
      console.error(`HomeComponent: Unable to parse ${sessionKey}.`, error);
    }
   }

  private storeSessionDataAndCheckRedirect(sessionRes: any, isPPI: boolean): void {

    // FIX: Always JSON.stringify when storing non-primitives or strings that might be parsed
    sessionStorage.setItem('WalletID', JSON.stringify(sessionRes.walletID));
    sessionStorage.setItem('WalletRole', JSON.stringify(sessionRes.walletRole)); // Also stringify WalletRole
    sessionStorage.setItem('sessionapimessage', JSON.stringify(sessionRes.message)); // Ensure this is also stringified consistently

    // Conditionally store ONL or PPI start session object
    if (isPPI && 'ppiStartWalletSession' in sessionRes) {
      sessionStorage.setItem('PPIWalletSession', JSON.stringify(sessionRes.ppiStartWalletSession));
      sessionStorage.removeItem('ONLWalletSession'); // Ensure only one type is stored
    } else if ('onlStartWalletSession' in sessionRes) {
      sessionStorage.setItem('ONLWalletSession', JSON.stringify(sessionRes.onlStartWalletSession));
      sessionStorage.removeItem('PPIWalletSession'); // Ensure only one type is stored
    } else {
      sessionStorage.removeItem('ONLWalletSession');
      sessionStorage.removeItem('PPIWalletSession');
      console.warn('Neither ONLWalletSession nor PPIWalletSession found to store.');
    }

    // Add JWTs to session storage as well
    sessionStorage.setItem('headers', sessionRes.dpatJWT);
    sessionStorage.setItem('walletheaders', sessionRes.ibJWT);

    this.checkSessionAndRedirect();
  }

  //   checkTcAcceptanceAndProceed(): void {
  //   console.log("checking tcAcceptance from home component: ");
  //   const isPPI = this.route.snapshot.routeConfig?.path === 'home/PPI/:id';
  //   this.walletSummaryService.fetchWalletSummary(this.walletId, this.walletRole).subscribe({
  //     next: (summary) => {
  //       summary.wallet.tcAcceptance === 0;
  //    //   console.log("Wallet summary fetched:", summary);
  //       this.walletSummary = summary;
  //       console.log("tcAcceptance value:", summary.wallet.tcAcceptance);  // This is added to check tcAcceptance value

  //       // Assuming tcAcceptance could be a string, explicitly convert to number if necessary
  //       const tcAcceptance = Number(summary.wallet.tcAcceptance);
  //       console.log("Converted tcAcceptance to number:", tcAcceptance);

  //       if (tcAcceptance === 0) {
  //         console.log("tcAcceptance is 0, should show modal");
  //         this.showTermsModal();
  //       } else if (tcAcceptance === 1 && this.walletRole === 'tandc') {
  //         console.log("tcAcceptance is 1 and walletRole is 'tandc', navigating to logged-out-tnc page");
  //         this.router.navigate(['logged-out-tnc']);
  //       } else {
  //         console.log("tcAcceptance is not 0, should load data");
  //         this.loadData(this.walletId, this.walletRole);
  //         this.isLoading = false; 
  //         //sessionStorage.setItem('walletDetails', JSON.stringify(summary?.wallet))
  //         try {
  //           sessionStorage.setItem('walletDetails', JSON.stringify(summary?.wallet));
  //         } catch (error) {
  //           console.error('Error setting session storage:', error);
  //         }
  //       }
  //     },
  //     error: (error) => {
  //       console.error("Error fetching wallet summary:", error);
  //       this.isLoading = false; 
  //     }
  //   });
  // }

  checkTcAcceptanceAndProceed(): void {
    console.log("checking tcAcceptance from home component: ");
    const isPPI = this.route.snapshot.routeConfig?.path === 'home/PPI/:id';

    // ONL branch (your current logic)
    this.walletSummaryService.fetchWalletSummary(this.walletId, this.walletRole).subscribe({
      next: (summary) => {
        this.walletSummary = summary;
        console.log("tcAcceptance value:", summary.wallet.tcAcceptance);

        // const tcAcceptance = Number(summary.wallet.tcAcceptance);
        let tcAcceptance = 0;
        let walletData: any;

        if (this.isPPI && summary.ppi && summary.ppi.wallet) {
          walletData = summary.ppi.wallet;
          tcAcceptance = Number(summary.ppi.wallet.tcAcceptance);
        } else if (!this.isPPI && summary.onl && summary.onl.wallet) {
          walletData = summary.onl.wallet;
          tcAcceptance = Number(summary.onl.wallet.tcAcceptance);
        } else {
          console.error('Wallet data not found in summary');
        }

        console.log("Converted tcAcceptance to number:", tcAcceptance);

        if (tcAcceptance === 0) {
          console.log("tcAcceptance is 0, should show modal");
          this.showTermsModal();
        } else if (tcAcceptance === 1 && this.walletRole === 'tandc') {
          console.log("tcAcceptance is 1 and walletRole is 'tandc', navigating to logged-out-tnc page");
          this.router.navigate(['logged-out-tnc']);
        } else {
          console.log("tcAcceptance is not 0, should load data");
          this.loadData(this.walletId, this.walletRole);
          this.isLoading = false;
          try {
            sessionStorage.setItem('walletDetails', JSON.stringify(summary?.wallet));
          } catch (error) {
            console.error('Error setting session storage:', error);
          }
        }
      },
      error: (error) => {
        console.error("Error fetching wallet summary:", error);
        this.isLoading = false;
      }
    });

  }


  showTermsModal(): void {
    console.log("Attempting to open modal");

    // this.sessionService.getProductType().subscribe(productType => {
    //   this.productType = productType;
    //   console.log('Current productType from Modal:', productType);
    // });

    if (this.walletSummary && this.walletSummary.wallet && this.walletSummary.wallet.payment) {
      this.productType = this.walletSummary.wallet.productType; // Extract productType
      this.billingType = this.walletSummary.wallet.billingType;         // Extract billingType
      console.log('ProductType from WalletSummary:', this.productType);
      console.log('BillingType from WalletSummary:', this.billingType);
    } else {
      console.error("WalletSummary or Wallet/Payment data is missing.");
      return; // Exit if walletSummary or required data is not available
    }

    this.isLoading = true; // Set loading to true when the modal opens

    const dialogRef = this.dialog.open(ModalTncWalletComponent, {
      width: '832px',
      height: '645px',
      disableClose: true,
      hasBackdrop: false,
      data: {
        policyNumber: this.policyNumber,
        walletId: this.walletId,
        walletRole: this.walletRole,
        productType: this.productType,
        billingType: this.billingType,
        productSystem: this.productSystem,
        checkTcAcceptanceAndProceed: this.checkTcAcceptanceAndProceed.bind(this)
      }
    });

    console.log('ProductType sent to modal:', this.productType); // Debug log
    console.log('BillingType sent to modal:', this.billingType); // Debug log


    const instance = dialogRef.componentInstance;
    instance.acceptClicked.subscribe(() => {
      dialogRef.updateSize('832px', '250px');
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("Modal closed with result:", result);
      this.isLoading = false; // Reset loading state when the modal closes
      if (result === 'accept') {
        //    console.log("accept clicked");
        let sessionID = sessionStorage.getItem("SessionID");
        const walletSetupData = {
          policyNumber: this.policyNumber,
          walletId: this.walletId,
          walletRole: this.walletRole,
          productType: this.productType,
          billingType: this.billingType,
          productSystem: this.productSystem,
          sessionID: sessionID
        };

        this.checkTcAcceptanceAndProceed();
      } else {
        this.router.navigate(['logged-out']);
      }
    });
  }


  initialCheckAndHandleModal(): void {
    let isPPI = false;
    if (this.route.snapshot.routeConfig && this.route.snapshot.routeConfig.path === 'home/PPI/:id') {
      isPPI = true;
    }


    this.sessionService.fetchSessionObject(this.id, isPPI).subscribe({
      next: (sessionRes) => {
        this.walletId = sessionRes.walletID;
        this.walletRole = sessionRes.walletRole;
        this.walletSummaryService.fetchWalletSummary(this.walletId, this.walletRole).subscribe({
          next: (summary) => {
            if (summary.wallet.tcAcceptance === 0 && !sessionStorage.getItem('hasAcceptedTnc')) {
              this.showTermsModal();
            } else {
              this.loadData(this.walletId, this.walletRole);
            }
          },
          error: (error) => console.error('Error fetching wallet summary:', error)
        });
      },
      error: (error) => console.error('Failed to fetch session object:', error)
    });
  }

  checkTermsAndLoadData(): void {
    const hasAcceptedTnc = sessionStorage.getItem('hasAcceptedTnc');
    if (hasAcceptedTnc || this.walletSummary?.wallet.tcAcceptance === 1) {
      this.loadData(this.walletId, this.walletRole);
    } else {
      this.showTermsModal();
    }
  }


  ngAfterViewInit(): void {

    this.positionTooltips();
    // This lifecycle hook can remain empty if there's no specific code to run after view initialization
  }

  // loadData(walletID: string, walletRole: string): void {
  //   this.isLoading = true;
  //   this.route.params.subscribe(params => {
  //     this.id = params['id'];
  //     if (this.id) {
  //       this.sessionService.fetchSessionObject(this.id).subscribe({
  //         next: (res) => {
  //           this.walletId = res.walletID;
  //           this.walletRole = res.walletRole;

  //           if (this.walletId && this.walletRole) {
  //             this.walletSummaryService.fetchWalletSummary(this.walletId, this.walletRole).subscribe({
  //               next: (summary) => {
  //                 this.walletSummary = summary; // Ensure this is set to update the view
  //                 if (summary && summary.wallet) {
  //                   this.totalCashBalance = summary.wallet.cash ? summary.wallet.cash.totalCashBalance : 'N/A';
  //                   this.totalRewardBalance = summary.wallet.rewards ? summary.wallet.rewards.totalRewardBalance : 'N/A';
  //                   this.totalRewardValue = summary.wallet.rewards ? summary.wallet.rewards.totalRewardValue : 'N/A';
  //                 }
  //               },
  //               error: (error) => console.error('Error fetching wallet summary:', error),
  //             });

  //             this.fetchTransactionHistory();
  //           }
  //         },
  //         error: (error) => console.error('Failed to fetch session object', error)
  //       });
  //     }
  //   });
  // }

  loadData(walletID: string, walletRole: string): void {
    this.isLoading = true;
    this.route.params.subscribe(params => {
      this.id = params['id'];
      let isPPI = false;
      if (this.route.snapshot.routeConfig && this.route.snapshot.routeConfig.path === 'home/PPI/:id') {
        isPPI = true;
        console.log('HomeComponent - Detected PPI Route (Load Data)');
      } else {
        console.log('HomeComponent - Detected ONL or other Route (Load Data)');
      }


      if (this.id) {
        // this.sessionService.fetchSessionObject(this.id, isPPI).subscribe({
        //   next: (res) => {
        //     this.walletId = res.walletID;
        //     this.walletRole = res.walletRole;

        //     if (this.walletId && this.walletRole) {
        //       this.walletSummaryService.fetchWalletSummary(this.walletId, this.walletRole).subscribe({
        //         next: (summary) => {
        //           this.walletSummary = summary; // Ensure this is set to update the view
        //           if (summary && summary.wallet) {
        //             this.totalCashBalance = summary.wallet.cash ? summary.wallet.cash.totalCashBalance : 'N/A';
        //             this.totalRewardBalance = summary.wallet.rewards ? summary.wallet.rewards.totalRewardBalance : 'N/A';
        //             this.totalRewardValue = summary.wallet.rewards ? summary.wallet.rewards.totalRewardValue : 'N/A';
        //           }
        //         },
        //         error: (error) => console.error('Error fetching wallet summary:', error),
        //       });

        //       this.fetchTransactionHistory();
        //     }
        //   },
        //   error: (error) => console.error('Failed to fetch session object', error)
        // });
      }
    });
  }


  fetchTransactionHistory(): void {
    this.transactionHistoryService.fetchTransactionHistory(this.walletId, this.walletRole, 'all').subscribe({
      next: (data) => {
        if (data && data.walletTransactionsList && data.walletTransactionsList.payments) {
          this.claimPayments = data.walletTransactionsList.payments.claimPayments;
        }
      },
      error: (error) => console.error('Error fetching transaction history:', error)
    });
  }


  initializeSessionAndCheckTnc(): void {
    let isPPI = false;
    if (this.route.snapshot.routeConfig && this.route.snapshot.routeConfig.path === 'home/PPI/:id') {
      isPPI = true;

    }

    this.sessionService.fetchSessionObject(this.id, isPPI).subscribe({
      next: (sessionRes) => {
        this.walletSummaryService.fetchWalletSummary(sessionRes.walletID, sessionRes.walletRole).subscribe({
          next: (summary) => {
            // Directly using tcAcceptance as it is already a number
            const tcAcceptance = summary.wallet.tcAcceptance;

            if (tcAcceptance === 1) {
              // If tcAcceptance is exactly 1, bypass the modal and load data
              this.loadData(sessionRes.walletID, sessionRes.walletRole);
            } else {
              // If tcAcceptance is not 1, show the modal
              this.showTermsModal();
            }
          },
          error: (error) => console.error('Error fetching wallet summary:', error),
        });
      },
      error: (error) => console.error('Failed to fetch session object:', error)
    });
  }

  clearSession() {
    sessionStorage.clear();
    localStorage.clear();
  }

  onSlide(event: NgbSlideEvent): void {
    this.activeSlideIndex = parseInt(event.current, 10);
  }

  navigateToSlide(slideIndex: number): void {
    this.carousel.select(slideIndex.toString());
    this.activeSlideIndex = slideIndex;
  }


  goToRedeem(): void {
    if (this.walletSummary?.wallet?.defaultPaymentMethod === "False") {
      // If default payment is NOT set, show the modal
      this.openSetDefaultPaymentModal('pay-invoice');
    } else {
      // If default payment is set, navigate to the outstanding balance page
      // this.buttonClick.goToRedeem();
      this.router.navigate(['/my-wallet/all-rewards/redeem/outstanding-invoice']);
    }
  }

  // “Turn on Auto-Redeem” might call something like:
  goToAutoRedeemSetup(): void {
    if (this.walletSummary?.wallet?.defaultPaymentMethod === 'False') {
      this.openSetDefaultPaymentModal('auto-redeem');
    } else {
      this.router.navigate(['/preferences/auto-redeem']);
    }
  }


  openSetDefaultPaymentModal(origin: string): void {
    const dialogRef = this.dialog.open(ModalDefaultPaymentComponent, {
      width: '600px',
      // data: { message: "To proceed with payment, please set your default payment method." }
      data: { origin }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'accept') {
        // Navigate to Manage Payment page with a flag that modal was shown
        this.router.navigate(['/preferences/manage-payment'],
          { queryParams: { from: origin } });
      }
    });
  }


  goToTransferBalance(): void {
    this.buttonClick.goToTransferBalance();
  }
  showTooltip(event: MouseEvent, tooltipType: 'rewards' | 'autoRedeem' | 'banks' | 'autoTransfer' | 'cashinfo'): void {
    this.tooltipVisibleForCashInfo = true;
  }
  hideTooltip(event?: MouseEvent): void {
    if (event) {
      event.stopPropagation();
    }
    this.tooltipVisibleForCashInfo = false;
  }
  positionTooltips() {
    this.positionTooltip(this.tooltipCashInfoElement, 'right');
  }

  positionTooltip(tooltipElement: ElementRef, alignment: 'left' | 'center' | 'right') {
    if (tooltipElement && tooltipElement.nativeElement) {
      const tooltip = tooltipElement.nativeElement;
      const button = tooltip.previousElementSibling;
      const buttonRect = button.getBoundingClientRect();
      const tooltipRect = tooltip.getBoundingClientRect();
      // Position tooltip above the button
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.positionTooltips();
  }
  handleClick(event: MouseEvent) {
    event.preventDefault(); // Prevent default behavior (if any)
    //this.hideTooltip();
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event) {
    //this.hideTooltip();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;
    const isInsideMenu = targetElement.closest('.redeem-menu');
    const isInsideTooltip = targetElement.closest('.tooltip');

    if (!isInsideMenu && !isInsideTooltip) {
      //this.hideTooltip();
    }
  }



}



